// src/services/api.js
import axios from 'axios';
import config from '../config';


/*const api = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});*/

// src/services/api.js
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.kreamun.com/api', // ← Debe ser la URL de la API
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token a todas las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('@kreamun:token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token inválido o expirado
      localStorage.removeItem('@kreamun:token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
		
// En api.js, agregar interceptor para errores 402
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 402) {
      // Redirigir a página de recarga o mostrar modal
      window.dispatchEvent(new CustomEvent('krums-insuficientes', { 
        detail: error.response.data 
      }));
    }
    return Promise.reject(error);
  }
);

// =============================================
// FUNCIONES DE AUTENTICACIÓN
// =============================================
export const login = (email, password) => 
  api.post('/auth/login', { email, password });

export const register = (userData) => 
  api.post('/auth/register', userData);

export const verifyToken = () => 
  api.get('/auth/verify');

// =============================================
// FUNCIONES DE HISTORIAS (ahora todas requieren token)
// =============================================
export const startStory = (formData) => 
  api.post('/stories/start', formData);
		
export const continueStory = (sesionId, opcionId) => 
  api.post('/stories/continue', { sesionId, opcionId });

export const getStory = (sesionId) => 
  api.get(`/stories/${sesionId}`);  // ← Template string correcto

export const listUserStories = () => 
  api.get('/stories');

export const getHealth = () => 
  api.get('/health');

// =============================================
// GESTIÓN DE HISTORIAS (NUEVAS)
// =============================================
export const updateStoryTitle = (sesionId, titulo) => 
  api.put(`/stories/${sesionId}/title`, { titulo });

export const deleteStory = (sesionId) => 
  api.delete(`/stories/${sesionId}`);

export const getStoryDetails = (sesionId) => 
  api.get(`/stories/${sesionId}/details`);
		
export const customAction = (sesionId, accionPersonalizada) => 
  api.post('/stories/custom-action', { sesionId, accionPersonalizada });
		
export const regenerateSegment = (sesionId, feedback) => 
  api.post('/stories/regenerate', { sesionId, feedback });

// =============================================
// PERFIL DE USUARIO
// =============================================
export const getProfile = () => 
  api.get('/profile');

export const updateProfile = (profileData) => 
  api.put('/profile', profileData);

export const changePassword = (currentPassword, newPassword) => 
  api.put('/profile/password', { currentPassword, newPassword });

export const updateEmailPreferences = (preferences) => 
  api.put('/profile/email-preferences', preferences);

export const deleteAccount = (password) => 
  api.delete('/profile', { data: { password } });

	  
// =============================================
// RECUPERACIÓN DE CONTRASEÑA
// =============================================
export const forgotPassword = (email) => 
  api.post('/auth/forgot-password', { email });

export const verifyResetToken = (token) => 
  api.get(`/auth/verify-reset-token/${token}`);

export const resetPassword = (token, newPassword) => 
  api.post('/auth/reset-password', { token, newPassword });
	  
	  
// =============================================
// MOSTRAR IMAGENES EN HISTORIA
// =============================================
	  
export const regenerateImage = (segmentoId) => 
  api.post(`/stories/${segmentoId}/regenerate-image`);
	  
export const getImageStyles = () => 
  api.get('/stories/image-styles');

export const regenerateImageWithStyle = (segmentoId, estilo) => 
  api.post(`/stories/${segmentoId}/regenerate-image`, { estilo });
	  
	  
// =============================================
// ADMINISTRACIÓN
// =============================================
export const listarUsuarios = () => api.get('/admin/usuarios');
export const toggleBloqueoUsuario = (userId, bloqueado) => 
  api.put(`/admin/usuarios/${userId}/block`, { bloqueado });
export const actualizarLimitesUsuario = (userId, limites) => 
  api.put(`/admin/usuarios/${userId}/limites`, limites);
	  
	  
export const enviarInvitacion = (email) => api.post('/admin/invitar', { email });
	  
// =============================================
// INVITACIONES
// =============================================
export const validarTokenInvitacion = (token) => 
  api.get(`/invitaciones/info/${token}`);

export const crearInvitacion = (email) => 
  api.post('/admin/invitaciones', { email });

export const listarInvitaciones = () => 
  api.get('/admin/invitaciones');

export const eliminarInvitacion = (id) => 
  api.delete(`/admin/invitaciones/${id}`);

export const reenviarInvitacion = (id) => 
  api.post(`/admin/invitaciones/${id}/reenviar`);
	  
// src/services/api.js
export const listarConfiguraciones = () => api.get('/config');
export const actualizarConfiguracion = (clave, valor) => 
  api.put(`/config/${clave}`, { valor });
export const getConfiguracionPublica = (clave) => 
  api.get(`/config/publica/${clave}`);	  
	  
	  
export const cambiarEstadoUsuario = (userId, estado) => 
  api.put(`/admin/usuarios/${userId}/estado`, { estado });
	  
// =============================================
// FEEDBACK BETA
// =============================================
export const enviarFeedback = (data) => 
  api.post('/feedback', data);

export const listarFeedback = (filtros = {}) => 
  api.get('/feedback', { params: filtros });

export const actualizarFeedback = (id, data) => 
  api.put(`/feedback/${id}`, data);

export const eliminarFeedback = (id) => 
  api.delete(`/feedback/${id}`);

export const getFeedbackStats = () => 
  api.get('/feedback/estadisticas');

export const listarMisFeedbacks = () => 
  api.get('/feedback/mis-reportes');
	  
// =============================================
// PLANES Y SUSCRIPCIONES
// =============================================
export const listarPlanes = () => 
  api.get('/planes');

export const getPlan = (id) => 
  api.get(`/planes/${id}`);

export const comprarPaquete = (planId, stripePaymentIntent) => 
  api.post('/planes/comprar', { plan_id: planId, stripe_payment_intent: stripePaymentIntent });

export const contratarSuscripcion = (planId, stripeSubscriptionId, stripeCustomerId) => 
  api.post('/planes/suscribirse', { 
    plan_id: planId, 
    stripe_subscription_id: stripeSubscriptionId,
    stripe_customer_id: stripeCustomerId 
  });

export const cancelarSuscripcion = () => 
  api.delete('/planes/suscripcion');

export const miSuscripcion = () => 
  api.get('/planes/usuario/suscripcion');

export const historialTransacciones = () => 
  api.get('/planes/usuario/transacciones');



// =============================================
// PLANES Y PAQUETES
// =============================================
export const listarPaquetes = () => 
  api.get('/planes');
	  
	  
// =============================================
// ADMIN - CONFIGURACIÓN DE KRUMS
// =============================================
export const listarCostos = () => api.get('/admin/krums/costos');
export const actualizarCosto = (id, data) => api.put(`/admin/krums/costos/${id}`, data);

export const getRecompensa = () => api.get('/admin/krums/recompensa');
export const actualizarRecompensa = (data) => api.post('/admin/krums/recompensa', data);

export const listarLimites = () => api.get('/admin/krums/limites');
export const actualizarLimite = (id, data) => api.put(`/admin/krums/limites/${id}`, data);

export const reclamarKrumsDiarios = () =>   api.post('/krums/reclamar-diario');

// =============================================
// KRUMS - SALDO Y CONSUMO
// =============================================
export const getSaldo = () => 
  api.get('/krums/saldo');

export const getCostosAcciones = () => 
  api.get('/admin/krums/costos'); // Solo admin
	  
// =============================================
// ESTADÍSTICAS Y MONITOREO
// =============================================
export const getDashboardStats = (periodo = '7d') => 
  api.get('/stats/dashboard', { params: { periodo } });

export const getAlertas = () => 
  api.get('/stats/alertas');

export const resolverAlerta = (id) => 
  api.put(`/stats/alertas/${id}/resolver`);

// =============================================
// PAGOS
// =============================================
export const crearIntencionPago = (planId, metodoPago = 'stripe') => 
  api.post('/pagos/crear-intencion', { planId, metodoPago });

export const historialPagos = () => 
  api.get('/pagos/historial');

export const verificarPagoMP = (paymentId) => 
  api.get(`/mercadopago/pago/${paymentId}`);

// src/services/api.js
export const getResumenFinanzas = () => 
  api.get('/finanzas/resumen');

export const getDetalleDiario = (dias = 30) => 
  api.get('/finanzas/detalle', { params: { dias } });

export const getCostosPorMotor = (periodo = '30d') => 
  api.get('/finanzas/motores', { params: { periodo } });

export const getUmbrales = () => 
  api.get('/finanzas/umbrales');

export const actualizarUmbral = (clave, valor) => 
  api.post('/finanzas/umbrales', { clave, valor });


export default api;